import "./solicitudAdquisicionA1.scss";
import Titulo from "../../components/atoms/titles/Titulo";
import { Formik, Form, ErrorMessage, Field } from "formik";
import Button from "../../components/atoms/buttons/Button";
import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";
import {
  getSolicitud,
  getSolicitudesA1,
  presentarSolicitud,
  sendBorrador,
  updateBorrador,
  updateBorradorAPresentada,
} from "../../components/services/AdquisicionService";
import { SpinnerCircle } from "../../components/atoms/spinner/Spinner";
import Header from "../../components/molecules/header/Header";
import Footer from "../../components/molecules/footer/Footer";
import DatePicker from "react-datepicker";
import { subDays } from "date-fns";
import ClausulaPDF from "../../resources/pdf/adquisicion/17604_proteccion_de_datos.pdf";
// import {
//   obtenerLocalidades,
//   obtenerProvincias,
// } from "../../components/services/ConcursosService";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { eliminarPropiedadObj, getDateFromString } from "../../utils/Utils";
import ModalPresentar from "../../components/molecules/modals/modalPresentar/modalPresentar";
const SolicitudAdquisicionA1 = () => {
  const [show, setShow] = useState({
    mensaje: false,
    modalPresentar: false,
  });  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [estado] = useState(false);
  const [disablePresentar, setDisablePresentar] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [user] = useLocalStorage("user", "");
  const [dataAdquisicion] = useState(
    JSON.parse(localStorage.getItem("dataAdquisicion"))
  );
  const [presentada] = useState(JSON.parse(localStorage.getItem("presentada")));

  const presentar = (valores) => {
    presentarSolicitud(valores).then((data) => {
      navigate("/adquisicion");
    });
  };

  const presentarBorrador = (valores) => {
    updateBorradorAPresentada(valores).then(() => {
      navigate("/adquisicion");
    });
  };

  const mandarBorrador = (valores) => {
    
    valores.estado = "BORRADOR";
    
    if (params?.id !== undefined) {
      updateBorrador(params?.id, valores).then(() => {
        
        navigate("/adquisicion");
      });
    } else {
      sendBorrador(valores).then((data) => {
        
        if (data.toString().startsWith("Error:")) {
          setShow({
            mensaje: true,
            content: data,
            tipo: "tituloBorrador",
            destinoAviso: null,
            destinoCerrar: null,
          });
        } else {
          setShow({
            mensaje: true,
            content: "Borrador guardado correctamente.",
            tipo: "tituloBorrador",
            destinoCerrar: "/adquisicion",
            destinoAviso: null,
          });
        }
      });
    }
  };
  let navigate = useNavigate();

  const handleClose = (e) => {
    setShow(false);
  };

  // const [borrador] = useState(false);

  const [datos, setDatos] = useState({
    // xweespeca1a2: 0,
    xniep: "",
    tipoespecialidad: "",
    nombre: "",
    primerapellido: "",
    segundoapellido: "",
    fechanacimiento: "",
    domicilio: "",
    localidad: "",
    provincia: "",
    codigopostal: "",
    telefonocontacto: "",
    correoe: "",
    cuerpopertenecefuncionario: dataAdquisicion.descripcionCuerpoA1,
    gradodiscapacidad: "",
    adaptacionsolicitada: "",
    abonocompleto: "1",
    exentoabono: "",
    gradodis33: "",
    victimaterr: "",
    victimagenero: "",
    identificador: null,
    estado: "BORRADOR",
    codprovincia: "",
    codlocalidad: "",
    fechacreacion: new Date(),
  });

  const peguntaPresentar = (valores) => {
    

    setShow({
      mensaje: true,
      content:
        "Va a realizar presentación de la Solicitud de reconocimiento de participación para la adquisición de la especialidad de empleo por los funcionarios de carrera pertenecientes al cuerpo de Titulados Superiores de la administración de la comunidad autónoma de Extremadura.",
      contentBold: "¿Estás seguro/a?",
      tipo: "tituloModal",
      funcion: params.id ? presentarBorrador : presentar,
      valorFuncion: valores,
      aviso: true,
      destinoAviso: null,
      destinoCerrar: null,
    });
  };

  useEffect(() => {
    getSolicitudesA1().then((data) => {
      if (!data.toString().startsWith("Error:")) {
        if (
          !data.filter((el) => el.xweespeca1a2 === parseInt(params.id)).length >
          0
        ) {
          // navigate("/adquisicion");
        }
      }
    });

    if (!params?.id) {
      setDatos((prevState) => ({
        ...prevState,
        primerapellido: user.apellido1,
        segundoapellido: user.apellido2,
        nombre: user.nombre,
        xniep: `${user.niep}${user.letniep}`,
      }));
      setLoading(true);
    } else {
      //Si el usuario acutal tiene ya un borrador hecho lo recoge
      
      if (params?.id !== undefined && params?.id !== null) {
        getSolicitud(params.id).then((data) => {
          
          setDatos((prevState) => ({
            ...prevState,
            codlocalidad: data.codlocalidad ? data.codlocalidad : "",
            codprovincia: data.codprovincia ? data.codprovincia : "",
            abonocompleto: data.abonocompleto ? data.abonocompleto : "",
            adaptacionsolicitada: data.adaptacionsolicitada
              ? data.adaptacionsolicitada
              : "",
            codigopostal: data.codigopostal ? data.codigopostal : "",
            correoe: data.correoe ? data.correoe : "",
            cuerpopertenecefuncionario: data.cuerpopertenecefuncionario
              ? data.cuerpopertenecefuncionario
              : "",
            fechanacimiento: data.fechanacimiento
              ? getDateFromString(data.fechanacimiento)
              : "",
            domicilio: data.domicilio ? data.domicilio : "",
            estado: data.estado ? data.estado : "",
            exentoabono: data.exentoabono ? data.exentoabono : "",
            fechacreacion: data.fechacreacion ? data.fechacreacion : "",
            gradodis33: data.gradodis33 ? data.gradodis33 : "",
            gradodiscapacidad: data.gradodiscapacidad
              ? data.gradodiscapacidad
              : "",
            identificador: data.identificador ? data.identificador : "",
            localidad: data.localidad ? data.localidad : "",
            provincia: data.provincia ? data.provincia : "",
            nombre: data.nombre ? data.nombre : "",
            primerapellido: data.primerapellido ? data.primerapellido : "",
            segundoapellido: data.segundoapellido ? data.segundoapellido : "",
            telefonocontacto: data.telefonocontacto
              ? data.telefonocontacto
              : "",
            tipoespecialidad: data.tipoespecialidad
              ? data.tipoespecialidad
              : "",
            victimagenero: data.victimagenero ? data.victimagenero : "",
            victimaterr: data.victimaterr ? data.victimaterr : "",
            xniep: data.xniep ? data.xniep : "",
            xweespeca1a2: data.xweespeca1a2 ? data.xweespeca1a2 : "",
          }));
          setStartDate(getDateFromString(data.fechanacimiento));
          setLoading(true);
        });
      }
    }
  }, [
    params,
    user.apellido1,
    user.apellido2,
    user.letniep,
    user.niep,
    user.nombre,
    navigate
  ]);
  return (
    <>
      <Header></Header>
      <div
        className="container d-flex flex-column min-vh-100 card mt-5"
        id="inicio"
        role="main" data-landmark-index="4"
      >
        {loading ? (
          <>
            <div className="my-auto">
              <div className="container-login fondo">
                <div className="tituloSolicitud">
                  <Titulo titulo={"Anexo"} tipo={"tituloPagina"} />
                  <div className="d-flex align-items-center flex-column">
                    <Titulo
                      titulo={
                        "SOLICITUD DE PARTICIPACIÓN PARA LA ADQUISICIÓN DE LA ESPECIALIDAD DE EMPLEO POR LOS FUNCIONARIOS DE CARRERA PERTENECIENTES AL CUERPO DE TITULADOS SUPERIORES DE LA ADMINISTRACIÓN DE LA COMUNIDAD AUTÓNOMA DE EXTREMADURA"
                      }
                      tipo={"tituloPagina subTituloPagina"}
                    />
                    <p className="text-third-1">{datos.estado}</p>
                  </div>
                  <div className="separador "></div>

                  <div className="infoSolicitud">
                    <div className="instrucciones">
                      <p className="my-3 mx-2">
                        Antes de cumplimentar y enviar esta solicitud, deberá
                        leer las instrucciones pinchando{" "}
                        <Link
                          to="/instruccionesSolicitudA1A2"
                          className="verde text-decoration-underline"
                        >
                          aquí
                        </Link>
                      </p>

                      <div className="separador "></div>
                    </div>
                    <p className="textoInfo p-2">
                      Al amparo de lo previsto en la Resolución de xx de xxxx de
                      2022, de la Vicepresidenta Primera y Consejera de Hacienda
                      y Administración Pública por la que se convoca
                      procedimiento para la adquisición de la especialidad de
                      Empleo por los funcionarios de carrera pertenecientes a
                      los Cuerpos de Titulados Superiores y Técnico de la
                      Administración de la Comunidad Autónoma de Extremadura,
                      solicita su participación en el procedimiento para la
                      adquisición de la especialidad de Empleo encuadrada en el
                      Cuerpo de Técnicos
                    </p>
                  </div>
                  <div className="datosPersonalesCarrera d-flex flex-column m-2">
                    <div>
                      <div className="separador"></div>
                      <div className="d-flex justify-content-between">
                        <Titulo
                          clases={"subSubTituloSolicitud p-2 fw-bold"}
                          tipo={"tituloCard noBg"}
                          titulo={"1. Datos personales"}
                        ></Titulo>
                        <p className="p-3 text-third-1">Campo obligatorio *</p>
                      </div>
                      <div className="separador"></div>
                    </div>

                    <div className="formulario">
                      <Formik
                        initialValues={{
                          xniep: datos?.xniep === "" ? "" : datos?.xniep,
                          tipoespecialidad: "A1",
                          nombre: datos?.nombre === "" ? "" : datos?.nombre,
                          primerapellido:
                            datos?.primerapellido === ""
                              ? ""
                              : datos?.primerapellido,
                          segundoapellido:
                            datos?.segundoapellido === ""
                              ? ""
                              : datos?.segundoapellido,
                          domicilio:
                            datos?.domicilio === "" ? "" : datos?.domicilio,
                          codprovincia: datos?.codprovincia,
                          codlocalidad: datos?.codlocalidad,
                          codigopostal:
                            datos?.codigopostal === ""
                              ? ""
                              : datos?.codigopostal,
                          telefonocontacto:
                            datos?.telefonocontacto === ""
                              ? ""
                              : datos?.telefonocontacto,
                          correoe: datos?.correoe === "" ? "" : datos?.correoe,
                          fechanacimiento: startDate === "" ? "" : startDate,
                          cuerpopertenecefuncionario:
                            datos?.cuerpopertenecefuncionario === ""
                              ? ""
                              : datos?.cuerpopertenecefuncionario,
                          gradodiscapacidad:
                            datos?.gradodiscapacidad === ""
                              ? ""
                              : datos?.gradodiscapacidad,
                          adaptacionsolicitada:
                            datos?.adaptacionsolicitada === ""
                              ? ""
                              : datos?.adaptacionsolicitada,
                          gradodis33: datos?.gradodis33 === "1" ? true : false,
                          victimaterr:
                            datos?.victimaterr === "1" ? true : false,
                          victimagenero:
                            datos?.victimagenero === "1" ? true : false,
                          identificador: null,
                          estado: "",
                          fechacreacion: new Date(),
                          tasaRadio:
                            datos?.abonocompleto === "1"
                              ? "Abono"
                              : datos?.exentoabono === "1"
                              ? "Exento"
                              : "0",
                          localidad:
                            datos?.localidad === "" ? "" : datos?.localidad,
                          provincia:
                            datos?.provincia === "" ? "" : datos?.provincia,
                        }}
                        validate={(valores) => {
                          const errores = {};
                          if (
                            valores.domicilio === null ||
                            valores.domicilio === ""
                          ) {
                            errores.domicilio = "Debe introducir un domicilio.";
                          }
                          if (
                            valores.codigopostal === null ||
                            valores.codigopostal === ""
                          ) {
                            errores.codigopostal =
                              "Debe introducir un Código Postal.";
                          }

                          if (
                            !/^(?:0[1-9]\d{3}|[1-4]\d{4}|5[0-2]\d{3})$/.test(
                              valores.codigopostal.toString()
                            )
                          ) {
                            errores.codigopostal = "Código postal no válido.";
                          }

                          if (
                            valores.telefonocontacto === null ||
                            valores.telefonocontacto === ""
                          ) {
                            errores.telefonocontacto =
                              "Debe introducir un teléfono.";
                          }
                          if (startDate === null || startDate === "") {
                            errores.fechanacimiento =
                              "Debe introducir una fecha.";
                          }
                          if (
                            !/\(?([0-9]{3})\)?([ -]?)([0-9]{3})\2([0-9]{3})$/.test(
                              valores.telefonocontacto
                            )
                          ) {
                            errores.telefonocontacto = "Teléfono no válido.";
                          }
                          if (
                            valores.correoe === null ||
                            valores.correoe === ""
                          ) {
                            errores.correoe = "Debe introducir un email.";
                          }
                          if (
                            valores.tasaRadio === "Exento" &&
                            valores.gradodis33 === false &&
                            valores.victimaterr === false &&
                            valores.victimagenero === false
                          ) {
                            errores.exento =
                              "Debes especificar al menos una causa.";
                          }

                          setDisablePresentar(true);
                          
                          
                          return errores;
                        }}
                        onSubmit={(valores) => {
                          if (
                            startDate !== null &&
                            datos.localidad !== null &&
                            datos.provincia !== null
                          ) {
                            //
                            valores.abonocompleto =
                              valores?.tasaRadio === "Abono" ? "1" : "0";
                            valores.exentoabono =
                              valores?.tasaRadio === "Exento" ? "1" : "0";
                            valores.victimagenero =
                              valores.exentoabono === "1"
                                ? valores?.victimagenero ||
                                  valores?.victimagenero === "1"
                                  ? "1"
                                  : "0"
                                : "0";

                            valores.victimaterr =
                              valores.exentoabono === "1"
                                ? valores?.victimaterr ||
                                  valores?.victimaterr === "1"
                                  ? "1"
                                  : "0"
                                : "0";

                            valores.gradodis33 =
                              valores.exentoabono === "1"
                                ? valores?.gradodis33 ||
                                  valores?.gradodis33 === "1"
                                  ? "1"
                                  : "0"
                                : "0";
                            valores.fechanacimiento =
                              startDate.toLocaleDateString("en-GB");
                            valores = eliminarPropiedadObj(
                              valores,
                              "tasaRadio"
                            );
                            if (valores.tipo === "submit") {
                              valores = eliminarPropiedadObj(valores, "tipo");
                              

                              if (!presentada) {
                                peguntaPresentar(valores);
                              } else {
                                setShow({
                                  modalPresentar: true,
                                  valores: valores,
                                });
                              }
                            }

                            if (valores.tipo === "borrador") {
                              valores = eliminarPropiedadObj(valores, "tipo");
                              
                              //

                              setShow({
                                mensaje: true,
                                contentBold: "",
                                content: "¿Desea Guardar el borrador?",
                                tipo: "tituloModal",
                                funcion: mandarBorrador,
                                valorFuncion: valores,
                                aviso: true,
                                destinoAviso: null,
                                destinoCerrar: null,
                              });
                            }
                          }
                        }}
                      >
                        {({ errors, values }) => (
                          <>
                            <Form>
                              <>
                                <div className="formularioDatosPesonalesA1 p-2">
                                  <div className="dniA1 me-2">
                                    <label htmlFor="dni">DNI:</label>
                                    <Field
                                      type="text"
                                      id="dni"
                                      name="xniep"
                                      className="form-control"
                                      placeholder="DNI"
                                      readOnly
                                      disabled
                                    />
                                    <ErrorMessage
                                      name="dni"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.dni}
                                        </div>
                                      )}
                                    />
                                  </div>

                                  <div className="nombreA1 ">
                                    <label htmlFor="nombre">Nombre:</label>
                                    <Field
                                      type="text"
                                      id="nombre"
                                      name="nombre"
                                      className="form-control"
                                      placeholder="Nombre"
                                      readOnly
                                      disabled
                                    />
                                    <ErrorMessage
                                      name="nombre"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.nombre}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="ape1A1 me-2">
                                    <label htmlFor="ape1">
                                      Primer Apellido:
                                    </label>
                                    <Field
                                      type="text"
                                      id="ape1"
                                      name="primerapellido"
                                      className="form-control"
                                      placeholder="Primer apellido"
                                      readOnly
                                      disabled
                                    />
                                    <ErrorMessage
                                      name="ape1"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.ape1}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="ape2A1 ">
                                    <label htmlFor="ape2">
                                      Segundo Apellido:
                                    </label>
                                    <Field
                                      type="text"
                                      id="ape2"
                                      name="segundoapellido"
                                      className="form-control"
                                      placeholder="Segundo apellido"
                                      disabled
                                    />
                                  </div>
                                  <div className="domicilioA1 ">
                                    <label htmlFor="domicilio">
                                      Domicilio <span className="rojo">*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="domicilio"
                                      name="domicilio"
                                      className="form-control"
                                      placeholder="Domicilio *"
                                    />
                                    <ErrorMessage
                                      name="domicilio"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.domicilio}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="provinciaA1 me-2">
                                    <label htmlFor="provincia">
                                      Provincia <span className="rojo">*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="provincia"
                                      name="provincia"
                                      className="form-control"
                                      placeholder="Provincia *"
                                    />
                                    <ErrorMessage
                                      name="provincia"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.provincia}
                                        </div>
                                      )}
                                    />

                                    <label className="mt-2" htmlFor="cp">
                                      CP <span className="rojo">*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="cp"
                                      name="codigopostal"
                                      className="form-control"
                                      placeholder="CP *"
                                    />
                                    <ErrorMessage
                                      name="codigopostal"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.codigopostal}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="localidadCPA1 me-2">
                                    <label htmlFor="localidad">
                                      Localidad <span className="rojo">*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="localidad"
                                      name="localidad"
                                      className="form-control"
                                      placeholder="Localidad *"
                                    />
                                    <ErrorMessage
                                      name="localidad"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.localidad}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="tlfContactoA1 me-2">
                                    <label htmlFor="tlf">
                                      Teléfono de contacto{" "}
                                      <span className="rojo">*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="tlf"
                                      name="telefonocontacto"
                                      className="form-control"
                                      placeholder="Teléfono de contacto *"
                                    />
                                    <ErrorMessage
                                      name="telefonocontacto"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.telefonocontacto}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="emailA1">
                                    <label htmlFor="email">
                                      Correo electrónico de contacto{" "}
                                      <span className="rojo">*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="email"
                                      name="correoe"
                                      className="form-control"
                                      placeholder="Correo electrónico de contacto *"
                                    />
                                    <ErrorMessage
                                      name="correoe"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.correoe}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="fechaNamA1 me-2">
                                    <label htmlFor="fechaNam">
                                      Fecha Nacimiento (dd/mm/yyyy){" "}
                                      <span className="rojo">*</span>:
                                    </label>
                                    <DatePicker
                                      selected={startDate}
                                      onChange={(date) => setStartDate(date)}
                                      name="fechanacimiento"
                                      id="fechanacimiento"
                                      className="form-control col-xxl-4 col-xl-4 col-lg-4 cold-md-4 cold-sm-4"
                                      dateFormat="dd/MM/yyyy"
                                      locale="es"
                                      placeholderText="Fecha de Nacimiento"
                                      maxDate={subDays(new Date(), 1)}
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                    />
                                    <ErrorMessage
                                      name="fechanacimiento"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.fechanacimiento}
                                        </div>
                                      )}
                                    />
                                  </div>
                                </div>
                              </>

                              <div className="datosProfesionales">
                                <div className="separador "></div>
                                <Titulo
                                  clases={"subSubTituloSolicitud p-2 fw-bold"}
                                  tipo={"tituloCard noBg"}
                                  titulo={"2. Datos profesionales:"}
                                ></Titulo>
                                <div className="separador "></div>

                                <div className="m-2">
                                  <label htmlFor="cuerpoPertenencia">
                                    Cuerpo de pertenencia que habilita su
                                    participación
                                    <span className="rojo"> *</span>:
                                  </label>
                                  <Field
                                    type="text"
                                    id="cuerpoPertenencia"
                                    name="cuerpopertenecefuncionario"
                                    className="form-control"
                                    placeholder="Cuerpo de pertenencia que habilita su
                                    participación"
                                    readOnly
                                  />
                                </div>
                              </div>
                              <div className="datosProfesionales">
                                <div className="separador "></div>
                                <Titulo
                                  clases={"subSubTituloSolicitud p-2 fw-bold"}
                                  tipo={"tituloCard noBg"}
                                  titulo={
                                    "3. Solicitud de adaptación en tiempo y medios necesarios para la realización del ejercicio:"
                                  }
                                ></Titulo>
                                <div className="separador "></div>
                                <div className="m-2">
                                  <label htmlFor="gradoDiscapacidad">
                                    Grado de discapacidad:
                                  </label>
                                  <Field
                                    type="text"
                                    id="gradoDiscapacidad"
                                    name="gradodiscapacidad"
                                    className="form-control"
                                    placeholder="Grado de discapacidad"
                                  />
                                </div>
                                <div className="m-2">
                                  <label htmlFor="adaptacionSol">
                                    Adaptación que solicita:{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    id="adaptacionSol"
                                    name="adaptacionsolicitada"
                                    className="form-control"
                                    placeholder="Adaptación que solicita"
                                  />
                                </div>
                              </div>
                              <div className="datosProfesionales">
                                <div className="separador "></div>
                                <Titulo
                                  clases={"subSubTituloSolicitud p-2 fw-bold"}
                                  tipo={"tituloCard noBg"}
                                  titulo={"4. Tasa por derecho de examen:"}
                                ></Titulo>
                                <div className="separador "></div>

                                <div className="obliga m-2">
                                  <div className="form-check">
                                    <Field
                                      className="form-check-input"
                                      type="radio"
                                      name="tasaRadio"
                                      id="tasaAbono"
                                      value="Abono"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="tasaAbono"
                                    >
                                      Abono completo de la tasa (38,52€)
                                    </label>
                                  </div>
                                  <div className="form-check">
                                    <Field
                                      className="form-check-input"
                                      type="radio"
                                      name="tasaRadio"
                                      id="tasaExento"
                                      value="Exento"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="tasaExento"
                                    >
                                      Exento del abono de la tasa por{" "}
                                      {values.tasaRadio === "Exento" ? (
                                        <span className="text-danger"> * </span>
                                      ) : null}
                                      :
                                    </label>
                                  </div>

                                  {values.tasaRadio === "Exento" ? (
                                    <>
                                      {/* Reseteo de checkboxes */}

                                      <div className="form-check ms-4 mt-2">
                                        <Field
                                          className="form-check-input"
                                          type="checkbox"
                                          name="gradodis33"
                                          id="gradodis33"
                                          checked={
                                            values.tasaRadio === "Exento" &&
                                            values.gradodis33
                                              ? true
                                              : false
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="gradodis33"
                                        >
                                          Grado de discapacidad igual o superior
                                          al 33%
                                        </label>
                                      </div>
                                      <div className="form-check ms-4">
                                        <Field
                                          className="form-check-input"
                                          type="checkbox"
                                          name="victimaterr"
                                          id="victimaterr"
                                          checked={
                                            values.tasaRadio === "Exento" &&
                                            values.victimaterr
                                              ? true
                                              : false
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="victimaterr"
                                        >
                                          Víctimas del terrorismo, cónyuges,
                                          parejas de hecho, así como sus hijos
                                        </label>
                                      </div>
                                      <div className="form-check ms-4">
                                        <Field
                                          className="form-check-input"
                                          type="checkbox"
                                          name="victimagenero"
                                          id="victimagenero"
                                          checked={
                                            values.tasaRadio === "Exento" &&
                                            values.victimagenero
                                              ? true
                                              : false
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="victimagenero"
                                        >
                                          Víctimas de violencia de género
                                        </label>

                                        <div className="error rojo pt-2">
                                          {errors.exento}
                                        </div>
                                      </div>
                                    </>
                                  ) : null}
                                </div>
                              </div>
                              <div className="datosProfesionales">
                                <div className="separador "></div>
                                <Titulo
                                  clases={"subSubTituloSolicitud p-2 fw-bold"}
                                  tipo={"tituloCard noBg"}
                                  titulo={
                                    "5. Declaración, consentimiento tratamiento de datos y espacio para la firma electrónica de la solicitud"
                                  }
                                ></Titulo>
                                <div className="separador "></div>

                                <div className="m-2">
                                  <p>
                                    La persona interesada, declara, bajo su
                                    expresa responsabilidad, la veracidad de los
                                    datos contenidos en la presente solicitud,
                                    quedando exonerada la Administración de la
                                    Comunidad Autónoma de Extremadura de
                                    cualquier responsabilidad derivada de los
                                    errores u omisiones de los mismos. FIRMA
                                    ELECTRÓNICA DE LA PERSONA INTERESADA
                                    (Espacio destinado para la firma
                                    electrónica)
                                  </p>
                                  <div style={{ marginTop: "10rem" }}></div>
                                  <p>
                                    ACEPTO Y DOY MI CONSENTIMIENTO expreso al
                                    firmar la presente solicitud para que sean
                                    tratados los datos personales de la misma
                                    con la única finalidad de que sea utilizados
                                    para gestionar mi participación en el
                                    procedimiento de adquisición de la
                                    Especialidad de Empleo en el Cuerpo al que
                                    pertenezco.
                                  </p>
                                </div>
                              </div>
                              <div className="datosProfesionales">
                                <div className="separador "></div>
                                <div className="d-flex align-items-center">
                                  <Titulo
                                    clases={"subSubTituloSolicitud p-2 fw-bold"}
                                    tipo={"tituloCard noBg"}
                                    titulo={
                                      "6.- Cláusula de protección de datos. Información adicional pinchando"
                                    }
                                  ></Titulo>
                                  <Link
                                    to="#"
                                    className="verde text-decoration-underline"
                                    onClick={() => {
                                      window.open(ClausulaPDF);
                                    }}
                                  >
                                    aquí
                                  </Link>
                                </div>
                                <div className="separador "></div>

                                <div className="proteccionDatosA1 m-2">
                                  <div className="responsableA1">
                                    RESPONSABLE del tratamiento
                                  </div>
                                  <div className="textResponsableA1">
                                    Vicepresidencia Primera y Consejería de
                                    Hacienda y Administración Pública.
                                  </div>
                                  <div className="finalidadA1">
                                    FINALIDAD del tratamiento
                                  </div>
                                  <div className="textFinalidadA1">
                                    El tratamiento de los datos se realiza con
                                    la finalidad de que sea gestinoada la
                                    solicitud de participación en el
                                    procedimiento para la adquisición de la
                                    Especialidad de Empleo del funcionario/a de
                                    carrera interesado.
                                  </div>
                                  <div className="legitimacionA1">
                                    LEGITIMACIÓN del tratamiento
                                  </div>
                                  <div className="textLegitimacionA1">
                                    El tratamiento de datos queda legitimado
                                    porque es necesario para el cumplimiento de
                                    una misión realizada en interés público o en
                                    el ejercicio de poderes públicos conferidos
                                    a la responsable del tratamiento.
                                  </div>
                                  <div className="derechosA1">
                                    DERECHOS de las personas interesadas
                                  </div>
                                  <div className="textDerechosA1">
                                    Acceso, rectificación, cancelación,
                                    supresión, limitación del tratamiento y
                                    oposición, así como otra información según
                                    se describe en la información adicional.
                                  </div>
                                </div>
                              </div>
                              <div className="footer">
                                <div className="direccion d-flex flex-column align-items-center  text-center">
                                  <p>DIRECCIÓN GENERAL DE FUNCIÓN PÚBLICA</p>
                                  <p>
                                    Servicio de Gestión y Provisión de Personal
                                  </p>
                                  <p className="text-center">
                                    Avda. Valhondo, s/n Edificio III Milenio -
                                    Módulo 1 - 1ª Planta - 06800 Mérida
                                  </p>
                                </div>
                              </div>
                              <div className="d-flex mb-2 flex-sm-row flex-column">
                                <button
                                  id="guardarSolicitudCarrera"
                                  className="btnRed rounded "
                                  type="button"
                                  onClick={() =>
                                    setShow({
                                      mensaje: true,
                                      content:
                                        "¿Deseas cancelar el formulario?",
                                      tipo: "tituloModal",
                                      aviso: true,
                                      destinoAviso: "/adquisicion",
                                      destinoCerrar: null,
                                    })
                                  }
                                >
                                  <i className="fa-solid fa-cancel"></i>{" "}
                                  Cancelar
                                </button>

                                <button
                                  id="grabarSolicitudCarrera"
                                  className="btn rounded"
                                  type="submit"
                                  onClick={
                                    Object.keys(errors).length === 0
                                      ? () => {
                                          values.tipo = "borrador";
                                        }
                                      : () => {
                                          setShow({
                                            mensaje: true,
                                            content:
                                              "Debe completar correctamente los datos obligatorios (Datos personales).",
                                            tipo: "tituloModal",
                                            contentClass: "rojo",
                                            destinoAviso: null,
                                            destinoCerrar: null,
                                          });
                                        }
                                  }
                                  disabled={!params.id && !disablePresentar}
                                >
                                  <i className="fa-solid fa-save"></i> Guardar
                                  Borrador
                                </button>
                                <button
                                  id="presentarSolicitudCarrera"
                                  className="btn rounded"
                                  type="submit"
                                  onClick={
                                    Object.keys(errors).length === 0 &&
                                    startDate !== null &&
                                    datos.localidad !== null &&
                                    datos.provincia !== null
                                      ? () => {
                                          values.tipo = "submit";
                                        }
                                      : () => {
                                          setShow({
                                            mensaje: true,
                                            content:
                                              "Debe completar correctamente los datos obligatorios (Datos personales).",
                                            tipo: "tituloModal",
                                            contentClass: "rojo",
                                            destinoAviso: null,
                                            destinoCerrar: null,
                                          });
                                        }
                                  }
                                  disabled={!params.id && !disablePresentar}
                                >
                                  <i className="fa-solid fa-file-circle-plus"></i>{" "}
                                  Presentar
                                </button>
                              </div>
                            </Form>
                          </>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="error rojo fs-4 pt-2 d-flex align-items-center flex-column my-auto">
              {estado ? (
                <>
                  {datos.estado}
                  <Button
                    id="btnCerrarConsultaIRPF"
                    clases="btn-card mt-3"
                    nombre="Volver"
                    tipo="button"
                    funcion={() => {
                      navigate("/home");
                    }}
                  />
                </>
              ) : (
                <SpinnerCircle></SpinnerCircle>
              )}
            </div>
          </>
        )}
      </div>
      <Footer></Footer>
      {show.mensaje ? (
        <>
          {" "}
          <ModalMensajes
            show={show.mensaje}
            handleClose={handleClose}
            content={show.content}
            tipo={show.tipo}
            aviso={show.aviso}
            destinoAviso={show.destinoAviso}
            destinoCerrar={show.destinoCerrar}
            funcion={show.funcion}
            valorFuncion={show.valorFuncion}
            boton={show.boton}
            contentBold={show.contentBold}
            contentClass={show?.contentClass}
          ></ModalMensajes>
        </>
      ) : null}

      {show.modalPresentar ? (
        <ModalPresentar
          show={true}
          handleClose={handleClose}
          peguntaPresentar={peguntaPresentar}
          valores={show.valores}
          destinoCerrar={show?.destinoCerrar}
        ></ModalPresentar>
      ) : null}
    </>
  );
};
export default SolicitudAdquisicionA1;
